export const imageAccommodation = {
  breadcrumbCurrent: "Logo de l'hébergement",
  heading: "Le logo de votre annonce",
  subtitle:
    "Téléchargez le logo qui identifie cette annonce. Formats autorisés : PNG, JPG, SVG · max. 5 Mo.",
  savedLogoAlt: "Logo enregistré",
  activeBadge: "Logo actif",
  change: "Changer",
  drop: {
    release: "Déposez-le ici",
    newLogo: "Nouveau logo",
    uploadLogo: "Téléchargez votre logo",
    dragOr: "Glissez ou",
    clickLink: "cliquez",
    formats: "PNG · JPG · SVG · max. 5 Mo",
  },
  importButton: "Importer le logo d'une autre annonce",
  crop: {
    removeImage: "Supprimer l'image",
    tip: "Déplacez et ajustez le recadrage. Ratio 2:1 (idéal pour les logos horizontaux).",
    saving: "Enregistrement…",
    save: "Enregistrer le logo",
  },
  actions: {
    cancel: "Annuler",
  },
  applyModal: {
    title: "Appliquer à d'autres annonces ?",
    subtitle: "Sélectionnez les annonces vers lesquelles copier ce même logo.",
    logoAlt: "Logo",
    selectAll: "Tout sélectionner",
    progress: "Application en cours {done}/{total}…",
    skip: "Ignorer",
    applying: "Application en cours…",
    applyToBtn: "Appliquer à {count} annonce | Appliquer à {count} annonces",
  },
  importModal: {
    title: "Importer le logo",
    subtitle: "Choisissez le logo d'une autre annonce à utiliser dans celle-ci.",
    loading: "Chargement des annonces…",
    empty: "Aucune annonce n'a encore de logo.",
    progress: "Importation du logo…",
    importing: "Importation en cours…",
  },
  defaultListingName: "Annonce",
  toasts: {
    invalidFormat: "Format non valide. Utilisez PNG, JPG ou SVG.",
    fileTooLarge: "Le fichier dépasse la limite de {max} Mo.",
    selectBeforeSave: "Sélectionnez et ajustez un logo avant d'enregistrer.",
    propertyNotFound: "La propriété liée à cette annonce est introuvable.",
    saveSuccess: "Logo enregistré avec succès",
    saveError: "Erreur lors de l'enregistrement du logo.",
    listingLoadError: "Impossible de charger les détails de l'annonce.",
    applySuccess:
      "Logo appliqué à {count} annonce avec succès | Logo appliqué à {count} annonces avec succès",
    applyError:
      "Impossible d'appliquer à {count} annonce | Impossible d'appliquer à {count} annonces",
    listingsLoadError: "Impossible de charger les annonces.",
    propertyNotFoundImport: "La propriété de cette annonce est introuvable.",
    importSuccess: 'Logo de "{name}" importé avec succès',
    importError: "Erreur lors de l'importation du logo.",
  },
};
